/**

 * Tenant configuration access — Firestore only.

 */



import { doc, getDoc, updateDoc } from 'firebase/firestore';

import { db } from '../firebase/firebase-config';

import { COLLECTIONS, SELECTABLE_TENANT_IDS } from '../platform/constants';

import { parseTenantConfig } from '../platform/tenantConfig';



function tenantDocRef(tenantId) {

  return doc(db, COLLECTIONS.TENANTS, tenantId);

}



/**

 * Load tenant config from Firestore. Throws when doc is missing or inactive.

 */

export async function fetchTenantConfigFromFirestore(tenantId) {

  const snapshot = await getDoc(tenantDocRef(tenantId));

  if (!snapshot.exists()) {

    throw new Error(`Tenant "${tenantId}" not found`);

  }

  const data = snapshot.data();

  if (data.status && data.status !== 'active') {

    throw new Error(`Tenant "${tenantId}" is not active`);

  }

  return data;

}



/**

 * Load and parse runtime tenant config from Firestore.

 */

export async function loadTenantConfig(tenantId) {

  const firestoreData = await fetchTenantConfigFromFirestore(tenantId);

  return parseTenantConfig(tenantId, firestoreData);

}



/**

 * Load branding previews for the organization picker.

 */

export async function loadSelectableOrganizations() {

  const results = await Promise.allSettled(

    SELECTABLE_TENANT_IDS.map(async (tenantId) => {

      const { config } = await loadTenantConfig(tenantId);

      return { tenantId, config };

    })

  );



  return SELECTABLE_TENANT_IDS.map((tenantId, index) => {

    const result = results[index];

    if (result.status === 'fulfilled') {

      return { ...result.value, error: null };

    }

    return {

      tenantId,

      config: null,

      error: result.reason?.message || 'Nalaganje ni uspelo',

    };

  });

}

/**
 * Persist tenant chat list group definitions (labels + order).
 */
export async function saveChatListGroups(tenantId, chatListGroups) {
  await updateDoc(tenantDocRef(tenantId), { chatListGroups });
}

/**
 * Persist tenant article/form list group definitions (labels, order, descriptions).
 */
export async function saveArticleListGroups(
  tenantId,
  articleListGroups,
  { essentialSectionSubtitle } = {},
) {
  const payload = { articleListGroups };
  if (essentialSectionSubtitle !== undefined) {
    payload.articleEssentialSectionSubtitle = essentialSectionSubtitle;
  }
  await updateDoc(tenantDocRef(tenantId), payload);
}


